import { render } from "./GalleryPage.vue?vue&type=template&id=927b78d6"
import script from "./GalleryPage.vue?vue&type=script&lang=js"
export * from "./GalleryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__